var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,0H5C3.3,0,2,1.3,2,3H1C0.4,3,0,3.4,0,4s0.4,1,1,1h1v2H1C0.4,7,0,7.4,0,8s0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1 s0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0,1.7,1.3,3,3,3h6c2.8,0,5-2.2,5-5V5 C16,2.2,13.8,0,11,0z M14,19c0,1.7-1.3,3-3,3H5c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h6c1.7,0,3,1.3,3,3V19z M12,7c0,0.6-0.4,1-1,1H7 C6.4,8,6,7.6,6,7s0.4-1,1-1h4C11.6,6,12,6.4,12,7z M21,0c-1.7,0-3,1.3-3,3v16.8c0,1.1,0.4,2.1,1.2,2.8l1.1,1.1 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.1-1.1c0.7-0.7,1.2-1.8,1.2-2.8V3C24,1.3,22.7,0,21,0z M22,19.8c0,0.5-0.2,1-0.6,1.4 L21,21.6l-0.4-0.4c-0.4-0.4-0.6-0.9-0.6-1.4V3c0-0.6,0.4-1,1-1s1,0.4,1,1V19.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.616c303556f820c6a28353b6f66344b1.svg";
export { ForwardRef as ReactComponent };